import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AdminUser } from 'src/types/shared/AdminUser';
import { ChallengeApplicationResponse } from 'src/types/shared/Challenge';

export const fetchSingleAdminUserRequest = createAction('fetchSingleAdminUserRequest');
export const fetchSingleAdminUserSuccess = createAction<AdminUser>('fetchSingleAdminUserSuccess');
export const fetchSingleAdminUserFailure = createAction('fetchSingleAdminUserFailure');

export const fetchSingleAdminUser = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchSingleAdminUserRequest());
    try {
        const { data }: UserResponse = await api.get(`admin/admins/${id}`);
        dispatch(fetchSingleAdminUserSuccess(data.user));
    } catch (e) {
        handleApiErrors(dispatch, fetchSingleAdminUserFailure, e);
    }
};

interface AdminUserResponse {
    user: AdminUser;
    challengeApplications: ChallengeApplicationResponse[];
}

interface UserResponse {
    data: AdminUserResponse;
}
